import { GridApi, RowNode } from '@ag-grid-community/core';
import { CdkPortalOutletAttachedRef, ComponentPortal } from '@angular/cdk/portal';
import { ChangeDetectorRef, Component, ComponentRef, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { ConfirmDialogComponent } from 'src/app/components/dialogs/confirm-dialog/confirm-dialog.component';
import { Order, ShipOrderDetails, ShipStationOrder } from 'src/app/models/fbmOrders.model';
import { ShipPackingSlipComponent } from 'src/app/modules/fbm-orders/batches/batch-details/ship-batch/ship-packing-slip/ship-packing-slip.component';
import { ShipStationService } from 'src/app/modules/fbm-orders/batches/batch-details/ship-batch/ship-station.service';
import { FbmOrdersService } from 'src/app/modules/fbm-orders/fbm-orders.service';
import { FbmFinancialsComponent } from './fbm-financials/fbm-financials.component';
import { FbmSkusComponent } from './fbm-skus/fbm-skus.component';
import { FulfilmentComponent } from './fulfilment/fulfilment.component';
import * as html2pdf from 'html2pdf.js';
import { GridActionsService } from 'src/app/data-grid/grid-actions.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { HeaderService } from 'src/app/components/header/header.service';
import { ShippingDialogComponent } from 'src/app/components/shipping-dialog/shipping-dialog.component';

@Component({
  selector: 'app-fbm-order-tool-panel',
  templateUrl: './fbm-order-tool-panel.component.html',
  styleUrls: ['./fbm-order-tool-panel.component.scss']
})
export class FbmOrderToolPanelComponent implements OnInit, OnDestroy {

  destroy: Subject<void> = new Subject<void>();
  gridApi: GridApi;
  orders: Array<Order> = new Array<Order>();
  lastOrder: Order = {} as Order;
  orderDetails: ShipOrderDetails = {} as ShipOrderDetails;
  markPickedIcon: string = "assets/images/fbm-order-icon/mark-check-icon.svg";
  minusIcon: string = "assets/images/fbm-order-icon/minus-icon.svg";
  arrowIcon: string = "assets/images/fbm-order-icon/polygon.svg";
  fulfilmentComponentPortal: any;
  skuComponentPortal: any;
  financialComponentPortal: any;
  packingSlipComponentPortal: any;
  globalSearch: string = "";
  shipStation: ShipStationOrder = {} as ShipStationOrder;
  loadingShipStation: boolean = false;
  haveShipOrder: boolean = false;
  isDefaultBehaviour: boolean = true;
  isSpinningPrintLabel: boolean = false;
  isDisabledPrintLabel: boolean = false;
  isSlipPrinting: boolean = false;
  currentNode: RowNode;
  displayedRows: number = 0;
  shipstationCarriers:any[] = [];
  shipOrderForm:FormGroup;
  actions = () => [];
  ordersShipingRateList:any[]=[];

  portals = {
    fulfilment: new ComponentPortal(FulfilmentComponent),
    skus: new ComponentPortal(FbmSkusComponent),
    financial: new ComponentPortal(FbmFinancialsComponent),
    packingSlip: new ComponentPortal(ShipPackingSlipComponent),
  };
  shipCarrierPackage:any[]=[];
  totalRate:number = 0;
  rateError:boolean=false;

  constructor(
    private fborderService: FbmOrdersService,
    private shipStationService: ShipStationService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    public gridActionsService: GridActionsService,
    private snackBar:MatSnackBar, 
    private headerService: HeaderService) {
      this.headerService.remoteActionBroadcaster.pipe(takeUntil(this.destroy),
      filter((e) => e.action === "PrintFbmLabel"  || e.action=='PrintPackingSlipBulk'))
      .subscribe((e) => {
        const index= this.fborderService.printFbmLabel.findIndex(res=>res.id == e.id);
        const printPackingIndex= this.fborderService.printPackingLabel.findIndex(res=>res.id == e.id);
          if(e.action === "PrintFbmLabel"  && index !== -1){
           if (e.response && e.response?.responseType == "success" && index !== -1) {
            this.fborderService.printFbmLabel.splice(index,1);
          if(e?.response?.message?.labelUrls){
            window.open( e.response.message.labelUrls, "_blank");
            } 
          if(e.response.message?.errors?.length){
              e.response.message.errors.forEach((el)=>{
                this.fborderService.showErrorMessage(el);
              })
            }        
         } else if(e.response && e.response?.responseType == "error" && index !== -1){
          this.fborderService.printFbmLabel.splice(index,1);
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: e.response?.message, 
                action: 'Dismiss',
                type: 'error',
              },
            }
          );
          }
        }
        if ( e.action === "PrintPackingSlipBulk" && printPackingIndex!== -1) {
          if (e.response && e.response?.responseType == "success" ) {
            this.fborderService.printPackingLabel.splice(printPackingIndex,1);

            this.gridApi?.refreshServerSide({ purge: true });
            if (e?.response?.message?.labelUrls) {
              window.open(e.response.message.labelUrls, "_blank");
            } 
            if (e.response.message?.errors?.length) {
              const formatErrorMessages = (messages) => {
                const ids = messages.map(msg => msg.split(' ')[0]).join(', ');
                return `${ids} Order detail is empty`;
              };
              const formattedMessage = formatErrorMessages(e.response.message?.errors);
               this.fborderService.showErrorMessage(formattedMessage);
            }
          } else if (e.response && e.response?.responseType == "error"  && printPackingIndex !== -1 ) {
            this.fborderService.printPackingLabel.splice(printPackingIndex,1);

            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: e.response?.message,
                  action: 'Dismiss',
                  type: 'error',
                },
              }
            );
          }
         }
      });
    }
  
  ngOnInit(): void {
    this.shipOrderForm = new FormGroup({
      service:new FormControl('',Validators.required),
      package:new FormControl('',Validators.required)
    })
  }

  agInit(params: any): void {
    this.gridApi = params.api;
  }

  private _isShowFulfilment: boolean = true;
  get isShowFulfilment(): boolean {
    return this._isShowFulfilment;
  }

  set isShowFulfilment(value: boolean) {
    this._isShowFulfilment = value;
    this.fulfilmentComponentPortal = value ? this.portals.fulfilment : null;
  }

  private _isShowSku: boolean = false;
  get isShowSku(): boolean {
    return this._isShowSku;
  }

  set isShowSku(value: boolean) {
    this._isShowSku = value;
    this.skuComponentPortal = value ? this.portals.skus : null;
  }

  private _isShowFinancial: boolean = false;
  get isShowFinancial(): boolean {
    return this._isShowFinancial;
  }

  set isShowFinancial(value: boolean) {
    this._isShowFinancial = value;
    this.financialComponentPortal = value ? this.portals.financial : null;
  }

  refresh() {
    this.shipstationCarriers = [];
    this.shipCarrierPackage = [];
    this.orders = this.gridApi.getSelectedRows();
    let lastOne = this.orders?.slice(0).pop();
    if (this.orders.length && lastOne.Orderid != this.lastOrder.Orderid) {      
      this.lastOrder = lastOne;
      if(this.lastOrder && (this.lastOrder?.Status === 'Shipped' || this.lastOrder?.Status === 'Delivered')&& !this.lastOrder.ShipstationLableUrl){
        this.isDisabledPrintLabel = true;       
      }  
      this.getfulfilment();
      this.isShowFulfilment = false;
      this.isShowSku = false;
      this.isShowFinancial = false;
      this.gridApi.forEachNode((node: any) => {
        if (node.data?.Orderid === this.lastOrder?.Orderid) {
          this.currentNode = node;
        }
      });
      this.displayedRows = this.gridApi.getDisplayedRowCount();          
    }
  }

  getfulfilment() {
    if (this.orders && this.lastOrder?.Orderid) {
      this.fborderService
        .getShipOrderDetailsByIdAndOrderId(
          { startRow: 0, endRow: 100 },
          this.lastOrder?.Orderid,
          this.globalSearch ?? '',
          this.lastOrder?.BatchsId || 0
        )
        .pipe(takeUntil(this.destroy))
        .subscribe({
        next: (response: any) => {
          this.orderDetails = response.data;
          if(this.orderDetails?.skuList?.length  == 1){
            this.shipStation.dimensions= this.orderDetails?.skuList[0].dimensions;
            this.shipStation.weight = this.orderDetails?.skuList[0].weight
            if(this.shipStation.weight.units == 'ounces'){
              this.shipStation.weight.value = Number((this.shipStation.weight.value / 16).toFixed(2))
            }
          }
          this.getShipStation();          
        },
        error: (err) => {

        },complete:()=>{
          this.isShowSku = true;
          this.isShowFinancial = true;
          this.isShowFulfilment = true;
        }
      });
    }
  }

  public onFulfilmentComponentRendering(ref: CdkPortalOutletAttachedRef): void {
    ref = ref as ComponentRef<any>;
    if (ref.instance.productList) {
      ref.instance.productList = this.orderDetails.productList;
    }
    ref.instance.shipStation = this.shipStation;
    if (ref?.instance?.refresh) {
         ref.instance.refresh.pipe(takeUntil(this.destroy)).subscribe((event) => {
        if(event?.dimensions){
          this.shipStation.dimensions=event?.dimensions;
        } else if(event?.weight){
          this.shipStation.weight=event?.weight;
        }
        this.getShipOrderRate(this.shipStation);
      });
    }
  }

  public onskuComponentRendering(ref: CdkPortalOutletAttachedRef): void {
    ref = ref as ComponentRef<any>;
    ref.instance.skuList = this.orderDetails.skuList;
  }

  public onFinancialComponentRendering(ref: CdkPortalOutletAttachedRef): void {
    ref = ref as ComponentRef<any>;
    if (ref.instance) {
      ref.instance['order'] = this.orders[0];
    }
  }

  onPackingSlipComponentRendering(ref: CdkPortalOutletAttachedRef): void {
    ref = ref as ComponentRef<any>;
    ref.instance.shipOrders = [this.lastOrder];
    ref.instance.orderDetails = this.orderDetails;
    ref.instance.shipStationOrders = [this.shipStation];
    ref.instance.single = true;
  }

  getShipStation() {
    if (this.orders && this.lastOrder?.Orderid) {
      this.loadingShipStation = true;
      this.packingSlipComponentPortal = null;
      this.totalRate=0;
      this.shipStationService
        .getOrdersShipingDetails(this.lastOrder?.Orderid,'shipstation',this.lastOrder?.account)
        .pipe(takeUntil(this.destroy))
        .subscribe({
        next: (response: any) => {
          this.loadingShipStation = false;
          if (response?.orders?.length) {
            if(this.orderDetails?.skuList?.length  == 1){
              response.orders[0].dimensions= this.orderDetails?.skuList[0].dimensions;
              response.orders[0].weight = this.orderDetails?.skuList[0].weight
              if(response.orders[0].weight.units == 'ounces'){
                response.orders[0].weight.value = (response.orders[0].weight.value / 16).toFixed()
              }
            } 
            this.loadAfterShipStation(response)
            if(this.lastOrder?.Status !== 'Shipped'&& this.lastOrder?.Status !== 'Delivered')
            this.getShipstationCarrier(false);           
          } else {
            this.shipStation = {} as ShipStationOrder;             
          }
        },
        error: (err) => {
          this.loadingShipStation = false;
        }
      });
    }
  }

  loadAfterShipStation(response: any): void {
    this.isDisabledPrintLabel = false;  
    this.shipStation =response.orders.slice(0).pop();    
    this.packingSlipComponentPortal = this.portals.packingSlip;        
     if(this.lastOrder && (this.lastOrder?.Status === 'Shipped' || this.lastOrder?.Status === 'Delivered')&& !this.lastOrder.ShipstationLableUrl){
        this.isDisabledPrintLabel = true;       
      }
  }

  getShipOrderRate(shipStationOrder: ShipStationOrder) {
    if (shipStationOrder.carrierCode && shipStationOrder.weight) {
      this.rateError=false;
      this.shipStationService
        .getOrdersShipingRate(shipStationOrder, this.lastOrder?.FromPostalCode)
        .pipe(takeUntil(this.destroy))
        .subscribe({
          next: (response: any) => {
            if(response.length){
              this.ordersShipingRateList=response;
              shipStationOrder.rate = (response[0]?.shipmentCost ?? 0) + (response[0]?.otherCost ?? 0);
              this.totalRate = shipStationOrder.rate;
            } else{
              this.totalRate =0;
            }
          },
          error: (err) => {
            this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 4000,
              horizontalPosition: 'center',
              data: {
                title: err.error.error[0],
                action: 'Dismiss',
                type: 'error',
              },
            }
          );
          this.totalRate =0;
          this.rateError=true;
          }
        });
    }
  }

  onRemoveFromBatch() {
    if (this.lastOrder?.BatchsId > 0) {
      this.dialog.open(ConfirmDialogComponent, {
        width: "500px",
        data: {
          title: "Remove from batch",
          message: `Are you sure you want to remove this order from the Batch ?`,
          actions: [
            { text: "Cancel", buttonStyle: "underline" },
            { text: "Confirm", buttonColor: "accent", buttonStyle: "wire" },
          ],
        },
      })
        .afterClosed()
        .pipe(filter((e) => e === "Confirm"))
        .subscribe((e) => {
          this.removeFromBatch();
        });
    }
  }

  removeFromBatch(): void {
    this.fborderService
      .removeFromBatch(this.lastOrder.BatchsId, [this.lastOrder.Orderid])
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (e) => {
          this.gridApi.refreshServerSide({ route: [], purge: true });
          (this.gridApi as any).obsrvr.next(true);
          this.fborderService.showSuccessMessage('Successfully removed orders from batch');
        },
        error: (err) => {
          this.fborderService.showErrorMessage('Operation unsuccessful, Please try again.');
        }
        });
  }

  onMarkasShipped() {
    this.dialog.open(ConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Mark as shipped batch",
        message: `Are you sure you want to mark orders as shipped?`
      },
    })
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .pipe(takeUntil(this.destroy))
      .subscribe((e) => {
        this.markAsPicked();
      });
  }

  markAsPicked(): void {
    let batchsId = this.lastOrder?.BatchsId > 0 ? this.lastOrder?.BatchsId : null;
    this.fborderService
      .markasShipped([this.lastOrder.Orderid], batchsId)
      .pipe(takeUntil(this.destroy))
      .subscribe({
      next: (res) => {
        (this.gridApi as any).obsrvr.next(true);
        this.lastOrder.Status = "Shipped";
        this.fborderService.showSuccessMessage("Successfull mark orders as shipped.");
      },
     error: (err) => {
          this.fborderService.showErrorMessage("Operation unsuccessful, Please try again.");
     }
    });
  }

  printLabelUsingUrl() {   
    this.isDisabledPrintLabel = true;
    this.isSpinningPrintLabel = true;
    const orderNumber = [this.lastOrder.Orderid];
    const selectedLabel =orderNumber.map(orderId => ({
      orderNumber: orderId
    }))
    const payload: any = {
      fbmLabelBulk:selectedLabel
    };
    this.shipStationService.PrintFbmLabelBulk(payload).pipe(takeUntil(this.destroy)).subscribe({
      next: (res:any) => {
      if(res) {
        this.fborderService.printFbmLabel.push({id:res.id});
        this.isDisabledPrintLabel = false;
        this.isSpinningPrintLabel = false;
      }
    },
     error: (err) => {
      this.isDisabledPrintLabel = false;
      this.isSpinningPrintLabel = false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 5000,
          horizontalPosition: 'center',
          data: {
            title: 'Error printing labels',
            action: 'Dismiss',
            type: 'error',
          },
        })
   }
 })
  }

  printLabelWithoutShipped() {
    this.shipStationService
      .printLabelUsingUrl(this.shipStation, this.lastOrder?.Orderid)
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (response: any) => {
          this.isDisabledPrintLabel = false;
          this.isSpinningPrintLabel = false;
          if (response?.printLabelUrl) {
            window.open(response.printLabelUrl, "_blank");
          }else{
            this.fborderService.showErrorMessage("Label not available");
          }
        },
       error: (err) => {
        this.isDisabledPrintLabel = false;
        this.isSpinningPrintLabel = false;
       }
     });
  }

  printLabelForShipped() {
    this.shipStationService
      .printLabelFromLocal(this.lastOrder?.Orderid)
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (response: any) => {
          this.isDisabledPrintLabel = false;
          this.isSpinningPrintLabel = false;
          if (response?.printLabelUrl) {
            window.open(response.printLabelUrl, "_blank");
          }else{
            this.fborderService.showErrorMessage("Label not available");
          }
        },
       error: (err) => {
        this.isDisabledPrintLabel = false;
        this.isSpinningPrintLabel = false;
       }
      });
  }

printLabelFromURL(printLabelUrl:string) {
   this.isDisabledPrintLabel = false;
   this.isSpinningPrintLabel = false;
     window.open(printLabelUrl, "_blank");
  }

  
  onPrintPickingSlip() {
      const selectedRow= this.gridApi.getSelectedRows();
      const selectedLabel = selectedRow.map((res: any) => {
        return  {
          OrderId: res.Orderid,
        }
      }); 
      const payload:any={
        ordersIds: selectedLabel
    }
      this.shipStationService.PrintPackingSlipBulk(payload).pipe(takeUntil(this.destroy)).subscribe({
        next:(res:any) => {
        if(res) {
          this.fborderService.printPackingLabel.push({id:res.id});
        }
      },
       error:(err) => {
            this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 5000,
              horizontalPosition: 'center',
              data: {
                title: 'Error packing slip',
                action: 'Dismiss',
                type: 'error',
              },
            }
          );
          }
        })
}

  onPrevious(): void {
    this.gridApi.forEachNode((node: any) => {
      if (node.rowIndex === (this.currentNode.rowIndex - 1)) {
        node.setSelected(true, true);
      } else {
        node.setSelected(false);
      }
    });
  }

  onNext(): void {
    this.gridApi.forEachNode((node: any) => {
      if (node.rowIndex === (this.currentNode.rowIndex + 1)) {
        node.setSelected(true, true);
      } else {
        node.setSelected(false);
      }
    });

  }

  private _copy: boolean = false;
  get copied(): boolean {
    return this._copy;
  }

  set copied(value) {
    this._copy = value;
  }

  copy(e) {
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 800);
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.unsubscribe();
  }

  getShipstationCarrier(getRate = true){
    this.shipStationService.getShipstationCarrierService().pipe(takeUntil(this.destroy)).subscribe({
      next: (res:any[]) => {
        if(res.length) {
          this.shipstationCarriers = res;
          let carrer=this.shipstationCarriers.filter((ele)=> ele.code == this.shipStation.carrierCode)
          if(carrer.length){
            let filterList=carrer[0].service.filter((s)=>s.code=== this.shipStation.serviceCode)
            if(filterList.length){
              this.shipOrderForm.get('service').setValue(filterList[0].name);
              this.shipStation.serviceCode = filterList[0].code;
              this.getCarrierPackage(carrer[0].shipStationCarrierId);
            } else {
              this.shipStation.carrierCode=res[0].code;
              this.shipOrderForm.get('service').setValue(res[0].service[0].name);
              this.shipStation.serviceCode = res[0].service[0].code;
              this.getCarrierPackage(res[0].shipStationCarrierId);
            }
          } else{
            this.shipStation.carrierCode=res[0].code;
            this.shipOrderForm.get('service').setValue(res[0].service[0].name);
            this.shipStation.serviceCode = res[0].service[0].code;
            this.getCarrierPackage(res[0].shipStationCarrierId);
          }          
        }
      },
     error: (error) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: error.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
    })
  }

  getCarrierPackage(ShipStationCarrierId){
    this.shipStationService.getShipstationCarrierPackage(ShipStationCarrierId).pipe(takeUntil(this.destroy)).subscribe({
      next: (res:any[]) => {
        if(res.length){
          this.shipCarrierPackage = res;
          let shipPacking=this.shipCarrierPackage.filter((ele)=> ele.code == this.shipStation.carrierCode);
          if(shipPacking?.length){
            let filterList=shipPacking[0].package.filter((s)=>s.code=== this.shipStation.packageCode);
            if(filterList.length){
            this.shipOrderForm.get('package').setValue(filterList[0].name);
            this.shipStation.packageCode =  filterList[0].code;
            } else{
              this.shipOrderForm.get('package').setValue(shipPacking[0].package[0].name);
              this.shipStation.packageCode =  shipPacking[0].package[0].code;
            }            
          }         
          this.getShipOrderRate(this.shipStation);
        }
      },
     error: (error) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: error.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
    );
   }
    })
  }

  onServiceChange(idx,index){
    this.shipStation.serviceCode = this.shipstationCarriers[idx].service[index].code;
    this.shipStation.carrierCode= this.shipstationCarriers[idx].code;
    this.getCarrierPackage(this.shipstationCarriers[idx].shipStationCarrierId);   
  }

  onPackageChange(idx,index){
    this.shipStation.packageCode = this.shipCarrierPackage[idx].package[index].code;
    this.getShipOrderRate(this.shipStation);
  }
  
  refreshService(){
    this.shipStationService.refreshShipStationCarrier().pipe(takeUntil(this.destroy)).subscribe({
      next: (res) => {
        if(res) this.getShipstationCarrier();
      },
     error: (error) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: error.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
    })
  }

  openShipping(){
    this.dialog.open(ShippingDialogComponent, {
      width: "800px",
      data: {
        ordersShipingRateList: this.ordersShipingRateList
      },
    }).afterClosed().subscribe((res)=>{
    });
  }
}
